/* eslint-disable */

// Check if the device is a touch device
export function checkTouchDevice() {
    if ("ontouchstart" in window || navigator.maxTouchPoints) {
        document.body.classList.add("touch-device");
    }
}
